import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { appointmentAsMemberQueryKeys } from "./appointmentAsMemberQueryKeys";

export const useInfiniteQueryAppointmentUpcomingAsMember = ({
  api,
  filters,
  enabled,
}: {
  api: ApiType;
  filters: Parameters<
    ApiType["customerAppointmentApi"]["appointmentUpcoming"]
  >[0]["filters"];
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey: appointmentAsMemberQueryKeys.appointmentUpcoming(filters),
    queryFn: async ({ pageParam }: { pageParam?: string }) => {
      return (
        await api.customerAppointmentApi.appointmentUpcoming({
          filters: {
            ...filters,
            nextPageToken: pageParam,
          },
        })
      ).data;
    },
    getNextPageParam: (lastPage) => lastPage.nextPageToken,
    initialPageParam: undefined,
    enabled,
  });
